module.exports = __webpack_public_path__ + "static/image-robot-8677c0612362f40b8eae20c87666ddad.svg";